import { ORTHOGRAPHY } from "../constants/orthography";

export const SORTED_ORTHOGRAPHY = [...ORTHOGRAPHY].sort(
  (a, b) => b.length - a.length
);
export const ORTHOGRAPHY_PATTERN = new RegExp(
  "(1|2|3|4|5|6|7|8|9|0|/|-|[*]|[+]|%)",
  "g"
);
